import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography, Button, Grid, Hidden, Link } from '@material-ui/core';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import ServiceLogoCard from '@/components/Cards/ServiceLogoCard';

// STYLES
import { Container } from './styles';

const services = [
  { src: getS3ImageUrl('/logos/services/espn-plus-white.svg'), title: 'ESPN+' },
  { src: getS3ImageUrl('/logos/services/hulu-white.svg'), title: 'Hulu' },
  { src: getS3ImageUrl('/logos/services/fubo-tv-white.svg'), title: 'Fubo TV' },
  {
    src: getS3ImageUrl('/logos/services/curiosity-white.svg'),
    title: 'CuriosityStream',
  },
  { src: getS3ImageUrl('/ParamountPlusLogoWhite.png', '/cp-uploads'), title: 'Paramount Plus' },
  { src: getS3ImageUrl('/logos/services/neflix-white.svg'), title: 'Netflix' },
];

const BannerWithApps = props => {
  const {
    className,
    title,
    subtitle,
    btnText,
    btnProps,
    secondaryBtnText,
    secondaryBtnProps,
  } = props;

  return (
    <Container className={clsx('banner', className)}>
      <div className="banner__section-left">
        {!!title && (
          <Typography className="banner__title m-b-20" variant="h4">
            {title}
          </Typography>
        )}
        {!!subtitle && (
          <Typography className="m-b-20" variant="body2">
            {subtitle}
          </Typography>
        )}
        <div className="banner__btns-wrapper">
          {!!btnText && (
            <Button className="banner__btn sizeExtraLarge" color="primary" {...btnProps}>
              {btnText}
            </Button>
          )}
          {!!secondaryBtnText && (
            <Link color="inherit" component="button" {...secondaryBtnProps}>
              {secondaryBtnText}
            </Link>
          )}
        </div>
      </div>
      <Hidden xsDown>
        <div className="banner__section-right">
          <Grid container spacing={2} justifyContent="center">
            {services.map((service, index) => (
              <Grid className={`hidden-xs icon-${index}`} item key={index}>
                <ServiceLogoCard
                  className="service-logo-card--banner"
                  src={service.src}
                  title={service.title}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      </Hidden>
    </Container>
  );
};

BannerWithApps.defaultProps = {
  className: '',
  title: '',
  subtitle: '',
  btnText: '',
  btnProps: {},
  secondaryBtnText: '',
  secondaryBtnProps: {},
};

BannerWithApps.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  subtitle: PropTypes.string,
  btnText: PropTypes.string,
  btnProps: PropTypes.object,
  secondaryBtnText: PropTypes.string,
  secondaryBtnProps: PropTypes.object,
};

export default React.memo(BannerWithApps);
